import CryptoJS from 'crypto-js'

export default {
  encrypt (src) {
    var key = CryptoJS.enc.Utf8.parse('ruigetech1201987')
    var val = CryptoJS.enc.Utf8.parse(src)
    var ret = CryptoJS.AES.encrypt(val, key, { iv: key, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.ZeroPadding })
    return CryptoJS.enc.Base64.stringify(ret.ciphertext)
  }
}



// WEBPACK FOOTER //
// ./src/utils/aes.js